import logo from './logo.svg'
import './App.css'
import EditablePage from './EditablePage'

function App() {
  return <EditablePage />
}

export default App
